import React from 'react';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { NodeVacancy } from '../../../types/uncinc_profile/nodes';
import NodeVacancyTeaser from './Teaser';

interface NodeVacancyProps {
  entity: ImmutableEntity<NodeVacancy>;
}

const NodeVacancyWrapper: React.FC<NodeVacancyProps> = ({ entity }) => (
  <NodeVacancyTeaser entity={entity} />
);

export default NodeVacancyWrapper;
